import request from '@/utils/request'

export function login(username, password) {
  const domain = process.env.VUE_APP_LOGIN_URL
  return request({
    url: domain + '/shop/agent/oauth/token',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/user',
    method: 'get'
  })
}
